import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import CountryFlagAndName from './countryFlagAndName.js'
import {_printNumber} from '../helpers/helpers.js'

import {TechnologyGeoData} from '../../../server/routes/route-types.js'

interface GeoData {
	Countries: TechnologyGeoData[];
	UserCountry?: string;
}

interface CountriesLeadListProps {
	report?: string;
	name?: string;
	reporttype?: string;
	geoData?: GeoData;
}

interface CountryLeadListProps {
	report?: string;
	reporttype?: string;
	country: TechnologyGeoData;
	line?: boolean;
}

export default function CountriesLeadList({report, name, reporttype, geoData}: CountriesLeadListProps) {

    if (!geoData || geoData.Countries == undefined) {
		return null;
	}	
	if (geoData.Countries.length == 0) {
		return null
	}	

    const userCountryName = geoData.UserCountry;
    let userCountryObj: TechnologyGeoData | null = null;
    
    let countries = geoData.Countries;

    if (userCountryName) {

        // find user-specific country in the list of all countries
        const userCountryIndex: number = countries.findIndex( (country) => {
            return country.Country == userCountryName && country.DomainCount > 0;
        })
        // if the user country is in the list ... move it to the front
        if (-1 != userCountryIndex) {
            userCountryObj = countries.splice(userCountryIndex, 1)[0];
            countries.unshift(userCountryObj);
        }
    }
    countries = countries.slice(0, 10); // show only 10 countries

	return (
		<>
        <br/>
        <h4>Website Distribution by Country</h4>
        Number of websites using {name}
        <table width="100%">
            <thead></thead>
            <tbody>
            {                                            
                countries.map((country, indexKey: number) => { 
                    const line: boolean = (indexKey == 1 && null != userCountryObj);  
                    if (country.Country == '') {                            
                        return (<tr key={indexKey} ></tr>);  
                    } ;           
                    return (
                        <CountryLeadList report={report}
                            reporttype={reporttype} country={country} 
                            line={line} key={indexKey} />
                    )
                })
            }
            </tbody>
        </table>
    </>
	)	
}

function CountryLeadList({report, reporttype, country, line}: CountryLeadListProps) {
    return (
        <>   
            {
                (line == true) &&
                <tr><td>
                    <br/>                               
                    <hr></hr>                 
                    <br/>                 
                </td>
                </tr>            
            }

            <tr>
                <td width="40%"><CountryFlagAndName countryCode={country.Country} /></td>
                <td width="60%">	
                     {
                        (reporttype == 'none') &&
                        <><b>{_printNumber(country.DomainCount)}</b> websites
                        </>
                     }
                     {
                        (reporttype != 'none') &&
                        <Link 
                            className="link-hover word-break" 
                            title={`Download Lead List`}									
                            to = {`/create-report?${reporttype}=${report}&country=${country.Country}`}
                        >
                        <b>{_printNumber(country.DomainCount)}</b> websites
                        </Link>	                        
                    }
								
                </td>						
            </tr> 
        </>     
    )

}

